import { Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { DataOrgService } from './data-org-service';
import { HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import * as dataorg from './data-org-queries';
import { AppConstants } from '../../constants/app-constants';
import { NeoUtilService } from '@bcone/neo-app-sdk';

@Component({
  selector: 'app-data-org',
  templateUrl: './data-org.component.html',
  styleUrls: ['./data-org.component.scss'],
  providers: [DataOrgService]
})
export class DataOrgComponent implements OnInit, OnChanges {
  @Input() currentNode;
  @Input() isVisible;
  @Input() isForPipeline;
  @Input() dataOrgNodeId;
  @Input() visitedPathInfo;
  @Input() foldersInfo;
  @Input() policyEnableComponentName;

  dataorg_label = AppConstants.userandfileaudit.dataorg;
  folders: any;
  node_id: string;
  node_dir: string;
  claimsObj: any;
  files: any;
  visitedPaths = [];
  fileObj: dataorg.FileInfo;
  folderInfo: dataorg.FolderInfo;
  selectedIndex: number;
  fileSelectedIndex: number;
  sortOptions: any;
  parent = '';
  policyList = [];
  groupList = [];

  constructor(
    private dataorgService: DataOrgService,
    public formBuilder: FormBuilder,
    private neoUtilService: NeoUtilService
  ) {

  }

  ngOnInit() {
    this.claimsObj = this.neoUtilService.getUserClaim();
    this.initializeDefaultValues();
    const parameters = new HttpParams();
    if (this.currentNode !== 'data org') {
      parameters.set('path', this.currentNode);
    }
    if (this.dataOrgNodeId) {
      this.readDataOrgFiles(this.dataOrgNodeId);
      this.setPreloadedData();
    }
    this.getObjectsfromltree(parameters);
  }
  ngOnChanges(changes: SimpleChanges) {
    let parameters;
    if (this.currentNode === 'data org') {
      parameters = new HttpParams();
    } else {
      parameters = new HttpParams().set('path', this.currentNode);
    }
    if (this.dataOrgNodeId) {
      this.readDataOrgFiles(this.dataOrgNodeId);
    } else {
      this.getObjectsfromltree(parameters);
    }
  }
  setPreloadedData() {
    this.visitedPaths = this.visitedPathInfo === undefined ? [] : this.visitedPathInfo;
    this.node_dir = this.currentNode;
    this.folders = this.foldersInfo;
  }

  initializeDefaultValues() {
    this.node_dir = '';
    this.node_id = 'id1';
    this.folders = [

    ];
    this.files = [
    ];
    this.sortOptions = '';
  }
  getNodes(folder) {
    this.selectedIndex = undefined;
    let current_dir;
    if (folder.node_dir) {
      current_dir = folder.node_dir;
    } else {
      current_dir = folder.node_name;
    }
    let parameters;
    parameters = new HttpParams().set('path', current_dir);
    if (this.sortOptions !== '') {
      parameters = parameters.set('sortoptions', this.sortOptions);
    }
    this.getObjectsfromltree(parameters);
    this.readDataOrgFiles(folder.data_org_node_id);
    this.visitedPaths.push(folder);
    this.folderInfo = folder;
  }
  getNodesFun(folder) {
    if (this.isForPipeline || this.policyEnableComponentName === 'dataexport') {
      console.log('data');
    } else {
      this.getNodes(folder);
    }
  }
  getObjects(node_dir, nodeName) {
    this.files = [];
    let parameters;
    if (nodeName === 'data org') {
      parameters = new HttpParams();
      this.visitedPaths = [];
    } else {
      parameters = new HttpParams().set('path', this.node_dir).set('subpath', nodeName);
      if (this.sortOptions !== '') {
        parameters = parameters.set('sortoptions', this.sortOptions);
      }
      let node_path_arr;
      let current_node_dir;
      if (node_dir.indexOf(nodeName) === 0) {
        current_node_dir = nodeName;
      } else {
        node_path_arr = node_dir.split('.' + nodeName);
        current_node_dir = node_path_arr[0] + '.' + nodeName;
      }
      const currentpathInfo = this.visitedPaths.filter(data => data.node_dir === current_node_dir)[0];
      this.selectedIndex = undefined;
      this.fileSelectedIndex = undefined;
      this.folderInfo = currentpathInfo;

      this.readDataOrgFiles(currentpathInfo.data_org_node_id);
    }
    this.getObjectsfromltree(parameters);
  }
  getObjectsfromltree(parameters) {
    this.dataorgService.getNodes(parameters).subscribe((res) => {
      this.folders = res.data;
      if (res.path) {
        this.node_dir = res.path;
      } else {
        this.node_dir = '';
      }
    });
  }
  readDataOrgFiles(orgId: string) {
    this.dataorgService.readDataByDataOrgNodeId(orgId, 'file').subscribe((res) => {
      this.files = res.data['sysDataOrgFiles']['nodes'];
    });
  }

  selectElement(_index: number, objInfo: any, type: string) {
    if (type === 'file') {
      this.selectedIndex = undefined;
      this.fileSelectedIndex = _index;
      this.fileObj = objInfo;
    } else {
      this.fileSelectedIndex = undefined;
      this.selectedIndex = _index;
      this.folderInfo = objInfo;
    }
  }
  hideDataOrgPane() {
    this.isVisible = false;
  }
}
